import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';

import {
  ONLINE_USERS_ATTRIBUTES_URL,
  ONLINE_USERS_TAGGS_URL,
  ONLINE_USERS_URL,
} from './Api';


const START_SEARCH = 'cam4/search/START_SEARCH';
const STOP_SEARCH = 'cam4/search/STOP_SEARCH';
const UPDATE_ONLINE_USERS = 'cam4/search/UPDATE_ONLINE_USERS';
const UPDATE_ONLINE_USERS_TAGGS = 'cam4/search/UPDATE_ONLINE_USERS_TAGGS';
const UPDATE_ONLINE_USERS_ATTRIBUTES = 'cam4/search/UPDATE_ONLINE_USERS_ATTRIBUTES';
const UPDATE_QUERY = 'cam4/search/UPDATE_QUERY';
const UPDATE_VISIBILITY = 'cam4/search/UPDATE_VISIBILITY';

const initialState = Immutable.fromJS({
  query: {
    value: '',
    isValid: false,
  },
  isStarted: false,
  onlineUsers: [],
  onlineUsersTaggs: [],
  onlineUsersAttributes: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_SEARCH:
      return state.set('isStarted', true);

    case STOP_SEARCH:
      return state.set('isStarted', false);

    case UPDATE_ONLINE_USERS:
      return state.set('onlineUsers', action.onlineUsers);

    case UPDATE_ONLINE_USERS_TAGGS:
      return state.set('onlineUsersTaggs', action.taggs);

    case UPDATE_ONLINE_USERS_ATTRIBUTES:
      return state.set('onlineUsersAttributes', action.attributes);

    case UPDATE_QUERY:
      return state.setIn(['query', 'value'], action.query);

    case UPDATE_VISIBILITY:
      return state.set('visibilityFilter', action.visibilityFilter);

    default:
      return state;
  }
}

export const NAME = 'search';

const search = (state) => state[NAME];
const visibilityFilter = (state) => state[NAME].get('visibilityFilter');
const query = (state) => state[NAME].getIn(['query', 'value']);
const isValidQuery = (state) => state[NAME].getIn(['query', 'isValid']);
const onlineUsers = (state) => state[NAME].get('onlineUsers');
const onlineUsersTaggs = (state) => state[NAME].get('onlineUsersTaggs');
const onlineUsersAttributes = (state) => state[NAME].get('onlineUsersAttributes');
const isStarted = (state) => state[NAME].get('isStarted');

export const selector = createStructuredSelector({
  search,
  query,
  isValidQuery,
  isStarted,
  onlineUsers,
  onlineUsersTaggs,
  onlineUsersAttributes,
  visibilityFilter,
});

function updateOnlineUsers(res) {
  return {
    type: UPDATE_ONLINE_USERS,
    onlineUsers: res.data,
  };
}

function updateOnlineUsersTaggs(res) {
  return {
    type: UPDATE_ONLINE_USERS_TAGGS,
    taggs: res.data,
  };
}

function updateOnlineUsersAttributes(res) {
  return {
    type: UPDATE_ONLINE_USERS_ATTRIBUTES,
    attributes: res.data,
  };
}
function updateVisibility(visibilityFilter) {
  return {
    type: UPDATE_VISIBILITY,
    visibilityFilter,
  };
}

function updateQuery(query) {
  return {
    type: UPDATE_QUERY,
    query,
  };
}

function startSearch() {
  return { type: START_SEARCH };
}

function stopSearch() {
  return { type: STOP_SEARCH };
}

function getOnlineUsers(query) {
  const params = { username: query };

  return (dispatch) =>
    ApiService.get(ONLINE_USERS_URL, { params })
      .then((res) => dispatch(updateOnlineUsers(res)));
}

function getOnlineUsersTaggs(query) {
  const params = {
    q: query,
    directoryJson: true,
    online: true,
    resultsPerPage: 8,
    showtag: query,
  };

  return (dispatch) =>
    ApiService.get(ONLINE_USERS_TAGGS_URL, { params })
      .then((res) => dispatch(updateOnlineUsersTaggs(res)));
}

function getOnlineUsersAttributes(query) {
  const params = {
    q: query,
    directoryJson: true,
    online: true,
    resultsPerPage: 8,
    haircolor: query,
  };

  return (dispatch) =>
    ApiService.get(ONLINE_USERS_ATTRIBUTES_URL, { params })
      .then((res) => dispatch(updateOnlineUsersAttributes(res)));
}

export const actionCreators = {
  getOnlineUsers,
  getOnlineUsersTaggs,
  getOnlineUsersAttributes,
  updateVisibility,
  updateQuery,
  startSearch,
  stopSearch,
};
